namespace Matrix.Indexation {
    export interface DimBasketConstituentForm {
        BasketIndexKey: Serenity.IntegerEditor;
        ConstituentIndexKey: Serenity.IntegerEditor;
        Generation: Serenity.IntegerEditor;
        IsCurrent: Serenity.StringEditor;
        EffectiveFrom: Serenity.StringEditor;
        EffectiveTo: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        HedgeRatio: Serenity.DecimalEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        DefaultSortOrder: Serenity.IntegerEditor;
    }

    export class DimBasketConstituentForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.DimBasketConstituent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DimBasketConstituentForm.init)  {
                DimBasketConstituentForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(DimBasketConstituentForm, [
                    'BasketIndexKey', w0,
                    'ConstituentIndexKey', w0,
                    'Generation', w0,
                    'IsCurrent', w1,
                    'EffectiveFrom', w1,
                    'EffectiveTo', w1,
                    'Weight', w2,
                    'HedgeRatio', w2,
                    'RowId', w0,
                    'Version', w3,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'DefaultSortOrder', w0
                ]);
            }
        }
    }
}
